"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorComponent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _plateCommon = require("@udecode/plate-common");
var _classVarianceAuthority = require("class-variance-authority");
var _cn = require("@udecode/cn");
var _withIndestructibleElements = require("../lib/withIndestructibleElements");
var _index = require("../forks/serializer-html/index");
var _utils = require("../lib/utils");
var _mentionContext = require("../lib/mentionContext");
var _htmlSerialiserUtils = require("../lib/htmlSerialiserUtils");
var _plateCore = require("@udecode/plate-core");
var _slate = require("slate");
var _useClickOutside = require("../hooks/useClickOutside");
var _jsxRuntime = require("react/jsx-runtime");
/* Manually installed and modified do not override */

var editorVariants = (0, _classVarianceAuthority.cva)((0, _cn.cn)('relative overflow-x-auto whitespace-pre-wrap break-words', 'min-h-[80px] w-full rounded-md bg-background px-4 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none', '[&_[data-slate-placeholder]]:text-muted-foreground [&_[data-slate-placeholder]]:!opacity-100', '[&_[data-slate-placeholder]]:top-[auto_!important]', '[&_strong]:font-bold'), {
  defaultVariants: {
    focusRing: true,
    size: 'sm',
    variant: 'default'
  },
  variants: {
    disabled: {
      true: 'cursor-not-allowed opacity-50'
    },
    focusRing: {
      false: '',
      true: 'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
    },
    focused: {
      true: 'ring-2 ring-ring ring-offset-2'
    },
    size: {
      md: 'text-base',
      sm: 'text-sm'
    },
    variant: {
      noBorder: 'min-h-[10px]  px-0 ',
      default: ''
    }
  }
});
function useEditorBlur(editor, onBlurHandler, wrapperRef) {
  var exportHtml = (0, _react.useCallback)(function () {
    (0, _utils.removeInlinePopups)(editor);
    var html = (0, _index.serializeHtml)(editor, {
      nodes: editor.children
    });
    return (0, _htmlSerialiserUtils.postProcessHtml)(html);
  }, [editor]);
  var handleBlur = (0, _react.useCallback)(function () {
    if (onBlurHandler) {
      onBlurHandler(exportHtml());
    }
  }, [exportHtml, onBlurHandler]);
  (0, _useClickOutside.useClickOutside)(wrapperRef, handleBlur);
  return {
    exportHtml: exportHtml,
    handleBlur: handleBlur
  };
}
function resetEditor(editor) {
  return function (newHtmlValue) {
    if (newHtmlValue && newHtmlValue.trim() !== '') {
      (0, _plateCommon.resetEditorChildren)(editor);
      var newValue = (0, _plateCore.deserializeHtml)(editor, {
        element: newHtmlValue
      });
      _slate.Transforms.select(editor, {
        anchor: {
          path: [0, 0],
          offset: 0
        },
        focus: {
          path: [0, 0],
          offset: 0
        }
      });
      editor.insertFragment(newValue);
    } else {
      (0, _plateCommon.resetEditorChildren)(editor);
    }
  };
}
var EditorComponent = exports.EditorComponent = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    focusRing = _ref.focusRing,
    focused = _ref.focused,
    readOnly = _ref.readOnly,
    size = _ref.size,
    variant = _ref.variant,
    onBlurHandler = _ref.onBlurHandler,
    peopleMentions = _ref.peopleMentions,
    labelMentions = _ref.labelMentions,
    dataCy = _ref['data-cy'],
    id = _ref.id,
    wrapperRef = _ref.wrapperRef,
    props = _objectWithoutProperties(_ref, ["className", "disabled", "focusRing", "focused", "readOnly", "size", "variant", "onBlurHandler", "peopleMentions", "labelMentions", 'data-cy', "id", "wrapperRef"]);
  var editor = (0, _plateCommon.useEditorRef)();
  var _useEditorBlur = useEditorBlur(editor, onBlurHandler, wrapperRef),
    exportHtml = _useEditorBlur.exportHtml;
  (0, _withIndestructibleElements.withIndestructibleElements)(editor);
  var _ref2 = (0, _mentionContext.useMentionContext)(),
    setPeopleMentions = _ref2.setPeopleMentions,
    setLabelMentions = _ref2.setLabelMentions;
  (0, _react.useEffect)(function () {
    if (peopleMentions) {
      setPeopleMentions(peopleMentions.map(function (peopleMentions) {
        return {
          key: peopleMentions.id,
          text: peopleMentions.text
        };
      }));
    }
  }, [peopleMentions, setPeopleMentions]);
  (0, _react.useEffect)(function () {
    if (labelMentions) {
      setLabelMentions(labelMentions.map(function (labelMentions) {
        return {
          key: labelMentions.id,
          text: labelMentions.text
        };
      }));
    }
  }, [labelMentions, setLabelMentions]);
  _react.default.useImperativeHandle(ref, function () {
    return {
      reset: resetEditor(editor),
      getHtmlValue: function getHtmlValue() {
        return exportHtml();
      }
    };
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "relative w-full",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_plateCommon.PlateContent, _objectSpread({
      id: id,
      "aria-disabled": disabled,
      className: (0, _cn.cn)(editorVariants({
        disabled: disabled,
        focusRing: focusRing,
        focused: focused,
        size: size,
        variant: variant
      }), className),
      "data-cy": dataCy + '-text',
      "data-testid": dataCy + '-text',
      disableDefaultStyles: true,
      readOnly: disabled !== null && disabled !== void 0 ? disabled : readOnly
    }, props))
  });
});
EditorComponent.displayName = 'Editor';